/* eslint-disable @typescript-eslint/no-unused-vars */
import { Datagrid, TextInput, TextField, useTranslate, useResourceContext } from 'react-admin'
import UploadIcon from '@mui/icons-material/Upload'
import { ListBase } from '../../components/base'
import { PRODUCTS_COMMON_FIELDS } from '../../providers/localization/constant'
import { ImportButton } from '../../components/buttons/ImportButton'
import { PreviewImage } from '../../components/fields/ImageField'

const BrandList = (): JSX.Element => {
  const translate = useTranslate()
  const brandListFilters = [
    <TextInput
      key={0}
      source='prod_brand_code'
      label={translate(`${PRODUCTS_COMMON_FIELDS}.prod_brand_code.label`)}
    />,
  ]

  const resource = useResourceContext()

  return (
    <ListBase
      listAction={{
        hasCreate: false,
        menuItems: [
          {
            label: `${PRODUCTS_COMMON_FIELDS}.import.title`,
            button: (
              <ImportButton
                label={translate(`${PRODUCTS_COMMON_FIELDS}.import.title`)}
                variant='contained'
                // ** todo import brand **
                to={`/import-master-data/brands/${resource}`}
                key={19}
                icon={<UploadIcon />}
              />
            ),
            visible: true,
          },
        ],
      }}
      perPage={50}
      filters={brandListFilters}
      sort={{ field: 'prod_brand_code', order: 'asc' }}
    >
      <Datagrid rowClick={null} bulkActionButtons={null}>
        <TextField
          source='prod_brand_code'
          label={`${PRODUCTS_COMMON_FIELDS}.prod_brand_code.label`}
        ></TextField>
        <PreviewImage
          label='Logo'
          source='logo.full_path'
          sortable={false}
          textAlign='center'
          sx={{
            justifyContent: 'center',
          }}
        />
        <TextField source='title_th' label={`${PRODUCTS_COMMON_FIELDS}.brand.title_th`}></TextField>
        <TextField source='title_en' label={`${PRODUCTS_COMMON_FIELDS}.brand.title_en`}></TextField>
      </Datagrid>
    </ListBase>
  )
}

export default BrandList
